import { UserState } from './state'
export const getters = {
  userInfo: (state: UserState) => state.userInfo,
  // tokenInfo: (state: UserState) => state.tokenInfo,
  // loginInfo: (state: UserState) => state.loginInfo,
}
